//import $this from "../../../../../wp-includes/js/dist/vendor/lodash";

jQuery(document).ready(function () {
    readMore();
    toggleBlockManualInternalLinking();
    toggleSearchform();
    faq_yoast();
    toggleFAQ();

    // gsap.config({
    //     nullTargetWarn: false,
    // });

    // Slider
    if(jQuery('.pgut-slider').length > 0){
        jQuery('.pgut-slider .pgut-arrow')
            .click(function(){
                scrollingLeft(jQuery(this));
            })
            .on('keypress',function(e) {
                if(e.which == 13) {
                    scrollingLeft(jQuery(this));
                }
        });
    }
});

var counter_effect = false;
jQuery(window).scroll(function(){
    // Activer l'effet Compteur quand on arrive dessus
    if(jQuery('.pgut-counter__number').length > 0){
        var top_window = jQuery('.pgut-counter__number').offset().top - window.innerHeight;
        if(!counter_effect && jQuery(window).scrollTop() > top_window){
            counterEffect();
            counter_effect = true;
        }
    }
});


// Animation de compteur de chiffres
function counterEffect() {
    jQuery('.pgut-counter__number').each(function () {
        var $this = jQuery(this);
        var split_string = $this.text().split(",");
        // Pour les nombres à décimales
        // On coupe la chaine en 2 et on fait deux compteurs différents
        if(split_string.length > 1){
            $this.html("<span class='pgut-counter__number-part'>"+split_string[0]+"</span>,<span class='pgut-counter__number-part'>"+split_string[1]+"</span>");
            jQuery.each(split_string, function(i, $val){;
                $val = $this.find('.pgut-counter__number-part').eq(i).text();
                jQuery({ Counter: 0 }).animate({ Counter: $this.find('.pgut-counter__number-part').eq(i).text() }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function (now) {
                        $this.find('.pgut-counter__number-part').eq(i).text(Math.ceil(now).toLocaleString());
                    }
                });
            });
        }
        else {
            jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    $this.text(Math.ceil(now).toLocaleString());
                }
            });
        }



    });
}

function initSortByPosts(){
    if(jQuery('#pgut-sort-by').length > 0){
        jQuery('#pgut-sort-by').on('change', function(){
            var sortValue = jQuery(this).val();
            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);

            // Update the sort_by parameter
            params.set('sort_by', sortValue);

            // Reload the page with the updated query parameters
            window.location.href = currentUrl.pathname + '?' + params.toString();
        });
    }
}

function readMore(action = 'hide'){
    let elements =  jQuery('.js-read-more');

    if (action === 'hide') {
        elements.each(function () {
            let parent = jQuery(this);
            let read_content = parent.nextAll().detach();
            let content_block = jQuery(this).closest('.wp-block-group').find('.js-read-more-content').appendTo(parent.parent());
            read_content.appendTo(content_block);
        });
    }

    elements.click(function (e) {
        e.preventDefault();

        let tl = gsap.timeline();
        tl.to(jQuery(this), {ease: 'power0', opacity: 0, overflow: 'hidden', display: 'none'});
        tl.to(jQuery(this).parent().next(), {
            ease: 'power0', opacity: 1, height: 'auto', onComplete: function () {
                ScrollTrigger.refresh();
            }
        });
    });
}
function toggleBlockManualInternalLinking(){
    // Block Internal Linking - Ouvrir / Fermer les accordéons
    if(jQuery('.pgut-manual-internal-linking').length > 0){
        jQuery('.pgut-manual-internal-linking .pgut-manual-internal-linking__heading').click(function(){
            jQuery(this).parent().toggleClass('open');
        });
    }
}

function toggleSearchform(){
    if(jQuery('.pgut-search').length > 0) {
        jQuery('.pgut-search__content').on('click', function () {
            jQuery(this).parent().toggleClass('pgut-search__open');

            if(jQuery(this).parent().hasClass('pgut-search__open')){
                jQuery('#pgut-searchform > input[type="text"]').focus();
            }
        });

        jQuery('.pgut-search__content__opened .pgut-icon').on('click', function () {
            jQuery(this).closest('.pgut-search').toggleClass('pgut-search__open');
        });
    }
}

// Scroll to left or right inside an element
function scrollingLeft(element_arrow) {
    var $arrow = jQuery(element_arrow);
    var $slider = $arrow.closest('.pgut-slider');
    var $container = $slider.find('.pgut-slider__container');
    var $left  = $slider.find('.pgut-arrow-left');
    var $right = $slider.find('.pgut-arrow-right');

    var width_scroll = ($slider.find('.pgut-slide').outerWidth(true)) || 18;
    var delta = $arrow.hasClass('pgut-arrow-left') ? -width_scroll : width_scroll;

    if($slider.hasClass('js-running')) {
        return;
    }

    $slider.addClass('js-running');

    $container.animate(
        { scrollLeft: $container.scrollLeft() + delta },
        {
            duration: "slow",
            complete: function() {
                var scrollLeft = $container.scrollLeft();
                var maxScroll = $container[0].scrollWidth - $container[0].clientWidth;

                // Début
                if (scrollLeft <= 0) {
                    $left.addClass('pgut-arrow__disabled').prop('disabled', true);
                } else {
                    $left.removeClass('pgut-arrow__disabled').prop('disabled', false);
                }

                // Fin
                if (scrollLeft >= maxScroll) {
                    $right.addClass('pgut-arrow__disabled').prop('disabled', true);
                } else {
                    $right.removeClass('pgut-arrow__disabled').prop('disabled', false);
                }

                $slider.removeClass('js-running');
            }
        }
    );
}

function updateSliderArrows($slider) {
    var $container = $slider.find('.pgut-slider__container');
    var $left  = $slider.find('.pgut-arrow-left');
    var $right = $slider.find('.pgut-arrow-right');

    var scrollLeft = Math.round($container.scrollLeft());
    var maxScrollLeft = Math.round($container[0].scrollWidth - $container[0].clientWidth);

    // tolérance pour éviter les flottants
    var EPS = 2;

    var atStart = scrollLeft <= EPS;
    var atEnd   = scrollLeft >= (maxScrollLeft - EPS);

    $left.toggleClass('disabled', atStart).attr('aria-disabled', atStart);
    $right.toggleClass('disabled', atEnd).attr('aria-disabled', atEnd);
}

function faq_yoast(){
    let $faq = jQuery('.wp-block-yoast-faq-block');

    if($faq.length) {
        $faq.each(function() {
            let $this = jQuery(this);
            let $faq_section = $this.find('.schema-faq-section');
            $faq_section.each(function() {
                let $this = jQuery(this);
                $this.attr('tabindex', '0');
                let $question = $this.find('.schema-faq-question');
                let $answer = $this.find('.schema-faq-answer');

                $question
                    .addClass('js-active')
                    .addClass('js-closed');

                $this
                    .on('focus', function () {
                        $answer.slideDown();
                        $question.removeClass('js-closed');
                    })
                    .on('focusout ', function () {
                        $answer.slideUp();
                        $question.addClass('js-closed');
                    })

            })
        })
    }
}

// Block FAQ - Open / Close
function toggleFAQ() {

    let $faq_tabs = jQuery('.wp-block-faq-tab');
    if( $faq_tabs.length > 0){

        $faq_tabs.each(function() {
            let $faq_tab = jQuery(this);
            let $faq_title = $faq_tab.find('.schema-faq-question');
            let $faq_icon = $faq_tab.find('.pgut-faq__icon');
            let $faq_answer = $faq_tab.find('.schema-faq-answer');

            $faq_icon.on('click', function(){
                $faq_tab.toggleClass('pgut-faq__is-open');
                $faq_answer
                    .prop('hidden', function(index, val) { return !val; });

                if( $faq_answer.prop('hidden') === true ){
                    $faq_title
                        .attr('aria-expanded', false);
                }
                else{
                    $faq_title
                        .attr('aria-expanded', true);
                }
            });
            $faq_title.on('click', function(){
                $faq_tab.toggleClass('pgut-faq__is-open');
                $faq_answer
                    .prop('hidden', function(index, val) { return !val; });

                if( $faq_answer.prop('hidden') === true ){
                    $faq_title
                        .attr('aria-expanded', false);
                }
                else{
                    $faq_title
                        .attr('aria-expanded', true);
                }

            });

        });
    }

    // if(jQuery('.pgut-faq__tab .pgut-faq__heading').length > 0){
    //     let $faq_headings = jQuery('.pgut-faq__tab .pgut-faq__heading');
    //     let $parent = $faq_headings.parent();
    //     let $faq_answer = jQuery('.pgut-faq__tab .pgut-faq__answer');
    //
    //     $faq_headings.on('click', function(){
    //         jQuery(this).parent().toggleClass('pgut-faq__is-open');
    //         $faq_answer
    //     })
    // }
}